import PropTypes from "prop-types";
import { withTranslation } from "@template/components/translation";
import PricingRow from "../PricingRow";

const Fees = ({ storeCode, text, formatTranslation }) => {
  if (storeCode !== "COM" || !text) {
    return null;
  }

  return (
    <PricingRow>
      <p>{formatTranslation("minibag_fees_title")}</p>
      <div data-test-id="miniBagFees">{text}</div>
    </PricingRow>
  );
};

Fees.defaultProps = {
  text: null
};

Fees.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  text: PropTypes.string,
  storeCode: PropTypes.string.isRequired
};

export default withTranslation(Fees);
